if (!customElements.get('c-auto-image-scroller')) {
  customElements.define('c-auto-image-scroller', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      this.images = Array.from(this.children).filter(image => !image.hasAttribute('data-scroller-clone'));
      if (!this.images.length) return;

      this.position = 0;
      this.distance = 0;
      this.visible = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.tick = this.animate.bind(this);
      this.updatePlayback = () => {
        cancelAnimationFrame(this.frame);
        this.previousTime = null;
        if (this.visible && !this.motion.matches && !document.hidden && this.distance > 0) {
          this.frame = requestAnimationFrame(this.tick);
        }
      };
      this.motion.addEventListener('change', this.updatePlayback);
      document.addEventListener('visibilitychange', this.updatePlayback);
      this.resizeObserver = new ResizeObserver(() => this.refresh());
      this.resizeObserver.observe(this);
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.updatePlayback();
      });
      this.intersectionObserver.observe(this.parentElement);
      this.refresh();
    }

    refresh() {
      this.querySelectorAll('[data-scroller-clone]').forEach(image => image.remove());
      this.distance = this.images.reduce((width, image) => {
        return width + image.getBoundingClientRect().width + parseFloat(getComputedStyle(image).marginRight);
      }, 0);
      if (this.distance > 0) {
        const copies = Math.ceil(this.clientWidth / this.distance);
        const fragment = document.createDocumentFragment();
        for (let copy = 0; copy < copies; copy++) {
          this.images.forEach(image => {
            const clone = image.cloneNode(true);
            clone.setAttribute('data-scroller-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            clone.alt = '';
            fragment.appendChild(clone);
          });
        }
        this.appendChild(fragment);
        this.position %= this.distance;
      }
      this.style.transform = `translateX(-${this.position}px)`;
      this.updatePlayback();
    }

    animate(time) {
      if (this.previousTime !== null) {
        this.position = (this.position + Math.min(time - this.previousTime, 64) * 0.06) % this.distance;
      }
      this.previousTime = time;
      this.style.transform = `translateX(-${this.position}px)`;
      this.frame = requestAnimationFrame(this.tick);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.motion?.removeEventListener('change', this.updatePlayback);
      if (this.updatePlayback) document.removeEventListener('visibilitychange', this.updatePlayback);
    }
  });
}
